<template>
  <div id="app" class="container">
    <InfoModal v-if="infoModal"  @close="hideInfoModal"></InfoModal>
    <div class="row" id="container">
      <div class="col-lg-3" id="titles">
        <template v-if="allTitles.slice(page*noPerPage, (page + 1)*noPerPage).length > 0">
          <Paginate :noofpages.sync="noOfpages" :page.sync="page" v-on:goto="goto" :noPerPage="noPerPage" :showrecordscount="false" :maxofrecords="noOfResults"></Paginate>
          <!--{{page}} {{noPerPage}}-->
          <!--{{allTitles.slice(page*noPerPage, (page + 1)*noPerPage)}}-->
          <h4>{{$t('listOfTitle')}}</h4>
          <!--{{allTitles}}-->
          <template v-for="(book, index) in allTitles.slice(page*noPerPage, (page + 1)*noPerPage)">
            <!--{{book}}-->
           <!--a {{book}}-->
            <Block :book='book' :no-of-characters=10 :key="index"></Block>
          </template>
          <Paginate :noofpages.sync="noOfpages" :page.sync="page" v-on:goto="goto" :noPerPage="noPerPage" :showrecordscount="false" :maxofrecords="noOfResults"></Paginate>
        </template>
      </div>
      <div class="col-lg-7" id="fulltext">
        <form class="form-inline" v-on:submit.prevent>
          <input class="form-control" style="width:80%" v-on:keyup.enter="searchForm" v-model.trim="keyword" placeholder="Search in full text" :disabled="searching" /><button type="button" class="btn"  v-on:click='searchForm' id='searchBtn' ><template v-if="!searching"><icon name='search'></icon></template><template v-if="searching"><icon name="spinner" pulse></icon></template></button> <a @click="showInfoModal"><div style="display:inline-block;vertical-align: bottom;" ><icon v-on:click="showInfoModal" name="info-circle" style="color:#b41815" scale='2'></icon></div></a>
        </form>
        <div class="row" style="padding-bottom:0.5em">About {{HRNumbers(noOfAllPagesHits)}} {{$t('pagesFoundsInTitles0')}} {{HRNumbers(noOfAllTitles)}} {{$t('pagesFoundsInTitles1')}} in CrossAsia full-text search</div>
        <div class="pageCluster">
          <template v-if="selectedBook!== null">
            <PageCluster :book='selectedBook' :highLightTerm='terms' :charToShow='charToShow' :wordToShow='wordToShow'></PageCluster>
          </template>
          <table>
            <thead>
              <tr>
                <td style="text-align:right;width: 30%">Collection</td>
                <td style="width: 30%">Solr cores</td>
                <td style="text-align:right;width: 10%">Titles</td>
                <td style="text-align:right;width: 20%">Pages</td>
              </tr>
            </thead>
            <tbody>
            <tr>
              <td colspan="4">
              <hr/>
              </td>
            </tr>
            <tr v-for="(core, index) in Object.keys($store.state.collections.totalNoOfBooks).sort()">
              <td style="text-align:left;vertical-align: middle;" >{{Object.entries(info).filter(x => x[1].core == core)[0][0]}}</td>
              <td style="text-align:left;vertical-align: middle;" >{{core}}</td>
              <td style="text-align:right;vertical-align: middle;" >{{$store.state.collections.totalNoOfBooks[core].toLocaleString(locale)}}</td>
              <td style="text-align:right;vertical-align: middle;">{{$store.state.collections.totalNoOfPages[core].toLocaleString(locale)}}</td>
            </tr>
            <tr>
              <td colspan="4">
              <hr/>
              </td>
            </tr>
            <tr>
              <td colspan="2">Total</td>
              <td style="text-align:right">{{HRNumbers(noOfAllTitles)}} ({{noOfAllTitles.toLocaleString(locale)}})</td>
              <td style="text-align:right">{{HRNumbers(noOfAllPagesHits)}} ({{noOfAllPagesHits.toLocaleString(locale)}})</td>
            </tr>
            </tbody>
          </table>
      <!-- {{$store.state.collections.totalNoOfBooks}} -->
      <br/><br/>
        </div>
      </div>
      <div class="col-lg-2" style="padding-left: 0px;">
        <!--{{selectedFacets}}-->
        <template v-if="Object.keys(selectedFacets).length > 0">
        <div class="blockRange row"><h4><span class="capitalize">Filter 
        <button type="button" class="btn"  v-on:click='toggleLock' id='lockBtn' >
          <template v-if="!lock"><icon name='unlock'></icon><span class="tooltiptext">Lock filter setting</span></template><template v-if="lock"><icon name="lock"></icon><span class="tooltiptext">Unlock filter setting</span></template></button>
        </span></h4>
          <table v-for="(items, facet) in selectedFacets">
            <tr v-for="(item) in items">
              <td style="vertical-align: top;"><a @click="removeFaceted(facet, item)" style="margin-right:5px"><label>(x)</label></a></td>
              <td><a @click="removeFaceted(facet, item)" style="margin-right:5px"><label>{{item.facet}}</label></a></td>
            </tr>
          </table>
        </div>
        </template>
        <!--{{facets}}-->
        <template v-for="(items, facet) in facets">
          <Facet :facet='facet' @select-Facets="selectFacets" :noOfItems='100' :info='info'></Facet>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

// import AsyncComputed from 'vue-async-computed'
// Import the Block (continuous pages) UI Module
// import Block from './Block'
import Block from './Block'

// Import the Paginate UI
import Paginate from './Paginate'

// import Header from './Header'
import Facet from './Facet'

import PageCluster from './PageCluster'

import InfoModal from './InfoModal'

import solrQuery from '../assets/solrQuery'

import setting from 'crossasia-itr-fulltextsearch-setting'

let HRNumbers = require('human-readable-numbers')

// import axios from 'axios'
import 'vue-awesome/icons/sort'
import 'vue-awesome/icons/search'
import 'vue-awesome/icons/spinner'
import 'vue-awesome/icons/book'
import 'vue-awesome/icons/database'
import 'vue-awesome/icons/file'
import 'vue-awesome/icons/info-circle'
import 'vue-awesome/icons/trash'
import 'vue-awesome/icons/unlock'
import 'vue-awesome/icons/lock'

import Icon from 'vue-awesome/components/Icon'
import range from 'lodash/range'

// import Vuex from 'vuex'
import 'es6-promise/auto'

const _ = {range: range}
import { debounce } from 'debounce'
const sources = setting.sources
// console.log(sources)

const info = setting.info

Vue.component('icon', Icon)
// Vue.use(AsyncComputed)

export default {
  created: function () {
    if (this.q && this.q.trim().length > 0) {
      this.keyword = this.q.trim()
      this.search()
    }
  },
  name: 'Stats',
  props: ['q'],
  components: {
    Paginate,
    // Header,
    Facet,
    PageCluster,
    Icon,
    InfoModal,
    Block
  },
  i18n: { // `i18n` option
    messages: {
      en: {
        listOfTitle: 'List of titles',
        pagesFoundsInTitles0: 'pages founds in',
        pagesFoundsInTitles1: 'titles',
        sortByNumberOfHitPages: 'Sort by number of hit pages',
        sortByRatio: 'Sort by ratio',
        hitPagesAllPages: '(hit pages/all pages)'
        // pages: 'pages'
      },
      de: {
        listOfTitle: 'Titelliste',
        pagesFoundsInTitles0: 'Seiten in',
        pagesFoundsInTitles1: 'Titeln gefunden', // 6259 Seiten in 2366 Titeln gefunden
        sortByNumberOfHitPages: 'Anzahl der Trefferseiten',
        sortByRatio: 'Verhältnis Treffer- zu Buchseiten',
        hitPagesAllPages: '(Treffer Seiten / alle Seiten)'
        // pages: 'Seiten'
      }
    }
  },
  data: function () {
    return {
      charToShow: {min: 15, max: 30},
      wordToShow: {min: 10, max: 20},
      // error: false,
      // direction: 'right',
      // searchByHits: true,
      start: false,
      initital: true,
      // heartBeat: 0,
      sources: sources,
      keyword: '',
      terms: [],
      // page: -1,
      noPerPage: 10,
      noOfResults: 0,
      // selectedBook: null,
      // pageHits: 0,
      searching: false,
      searchingThreads: {},
      // message: '',
      locale: this.$i18n.locale,
      info: info,
      infoModal: false,
      searchDebounce: debounce(this.realSearch, 2000),
      lock: false
      // workers: []
    }
  },
  methods: {
    HRNumbers: function (input) {
      return HRNumbers.toHumanString(input)
    },
    hideInfoModal: function () {
      this.infoModal = false
      // console.log(this.infoModal)
    },
    showInfoModal: function () {
      this.infoModal = true
      // console.log(this.infoModal)
    },
    toggleLock: function () {
      this.lock = !this.lock
    },
    // Callback
    // restart: function () {
    //   // console.log('restart')
    //   this.$router.push({name: 'frontPage'})
    // },
    // sortByPageHits: function () {
    //   this.searchByHits = true
    //   this.$store.dispatch('records/sortRecords', true)
    //   // this.page = 0
    // },
    // sortByPageHitsRatio: function () {
    //   this.searchByHits = false
    //   this.$store.dispatch('records/sortRecords', false)
    //   // this.page = 0
    // },
    // selectBook: function (book) {
    //   this.selectedBook = book
    // },
    removeFaceted: function (facet, item) {
      // console.log({name: facet, item: item})
      this.$store.dispatch('collections/removeSelectedFacet', {name: facet, item: item})
      this.search(false)
    },
    goto: function (event) {
      // this.page = parseInt($(event.target).attr('pageno')) || 0
      this.$store.dispatch('collections/setPage', {page: parseInt($(event.target).attr('pageno'))})
    },
    selectFacets: function (facet, item) {
      this.$store.commit('collections/selectFacetItem', {name: facet, item: item})
      this.search(false)
    },
    searchForm: function () {
      this.search(!this.lock)
    },
    search: function (reset = true) {
      // alert(reset)
      if (reset) {
        this.$store.dispatch('collections/reset')
      } else {
        this.$store.dispatch('collections/filterReset')
      }
      this.searching = true
      this.books = {}

      let vm = this
      Object.keys(this.sources).forEach(function (sourceKey) {
        vm.searchingThreads[sourceKey] = true
      })
      this.searchDebounce.clear()
      this.searchDebounce()
      // Split the keyword with space as a term list and filter the empty element(s).
    },
    realSearch: function () {
      // this.workers.forEach((x) => x.terminate())
      let vm = this
      // let vm = this
      this.keyword = this.keyword.replace(/\*+/g, '*')
      let keyword = this.keyword.split('').reduce(function (accumulator, currentValue) {
        // console.log(accumulator.spaceResiteMode)
        // console.log(accumulator.keyword)
        // console.log(currentValue)
        // console.log(currentValue === '"')
        let newKeyword = accumulator.keyword + ((currentValue === ' ' && accumulator.spaceResiteMode) ? '-----' : currentValue)
        let newSpaceResiteMode = accumulator.spaceResiteMode
        if (!newSpaceResiteMode && currentValue === '"') {
          newSpaceResiteMode = true
        } else if (newSpaceResiteMode && currentValue === '"') {
          newSpaceResiteMode = false
        }
        return {keyword: newKeyword, spaceResiteMode: newSpaceResiteMode}
      }, {keyword: '', spaceResiteMode: false}).keyword
      // console.log(this.keyword)
      this.terms = keyword.split(' ').map(function (term) {
        let newTerm = term.replace(/-----/g, ' ').replace(/["[\]{}()+?\\^$|#]/g, '')
        return (newTerm.slice(-1) !== '*') ? '"' + newTerm + '"' : newTerm
      }).filter(function (term) { return term.length > 2 })
      this.terms = this.terms.length === 0 ? ['*'] : this.terms
      vm.$store.dispatch('collections/setTerms', {terms: this.terms})
      // console.log(this.terms)
      vm.$store.dispatch('collections/setNoOfFetch', {noOfFetch: Object.keys(this.sources).length})
      if (this.terms.length > 0) {
        // Object.keys(sources).forEach(function (sourceKey) {
        //   solrQuery.fetchNoOfBook(vm, sourceKey)
        // })
        // let faceted = Object.entries(this.selectedFacets).reduce((acc, x) => {
        //   acc[x[0]] = x[1].map(y => y.facet)
        //   return acc
        // }, {})
        // let trackSiteSearch = Object.keys(faceted).length > 0 ? JSON.stringify({terms: this.keyword, faceted: faceted}) : this.keyword
        // console.log(trackSiteSearch)
        // if (typeof window._paq === 'object') {
        //   window._paq.push(['trackSiteSearch', trackSiteSearch, 'fulltextsearch_a', 'false'])
        // } else {
        //   console.log(trackSiteSearch)
        // }
        Object.keys(sources).forEach(function (sourceKey) {
          // if (sourceKey === 'minguo') {
          solrQuery.fetchNoOfBook(vm, sourceKey)
          // solrQuery.fetchBookId(vm, sourceKey)
          // solrQuery.fetchBooksMetaData(vm, sourceKey)
          // }
        })
        this.keepSearch()
      } else if (this.initital) {
        // Generate ajax solr queries base on the configuration above.
        Object.keys(sources).forEach(function (sourceKey) {
          solrQuery.fetchNoOfBook(vm, sourceKey)
        })
      }
    },
    keepSearch: function (key = null) {
      let vm = this
      // let jobs = vm.$store.getters['collections/getJobs']
      // console.log(jobs)
      setTimeout(() => {
        // let done = true
        // if (key === null) {
        //   Object.keys(this.sources).forEach(function (sourceKey) {
        //     let job = [sourceKey, vm.$store.getters['collections/getNoOfBooks'](sourceKey), vm.$store.getters['collections/getTotalNoOfBooks'](sourceKey)].join('-')
        //     // if (sourceKey === 'minguo') {
        //     // }
        //   })
        // }
        //  else {
        //   let sourceKey = key
        //   let job = [sourceKey, vm.$store.getters['collections/getNoOfBooks'](sourceKey), vm.$store.getters['collections/getTotalNoOfBooks'](sourceKey)].join('-')
        // }
        vm.searching = false
        // vm.searching = false
      }, 1000)
    }
  },
  watch: {
    // selectedFacets: {
    //   handler: function (newCount, oldCount) {
    //     this.search()
    //   },
    //   deep: true
    // },
    page: function () {
      let displayTitles = this.allTitles.slice(this.page * this.noPerPage, (this.page + 1) * this.noPerPage)
      if (displayTitles.length > 0) {
        this.$store.dispatch('collections/setSelectedBook', {selectedBook: displayTitles[0]})
      }
      if (this.page * this.noPerPage / this.allTitles.length > 0.09 && this.allTitles.length < this.noOfAllTitles) {
        // console.log('load more', this.allTitles.length, this.noOfAllTitles)
        this.keepSearch()
      }
    }
    // selectBook: function () {
    //   if (this.selectBook == null) {
    //     document.getElementById('fulltext').setAttribute('style', 'display:none')
    //   } else {
    //     document.getElementById('fulltext').setAttribute('style', '')
    //   }
    // }
  },
  mounted: function () {
    let vm = this
    vm.$store.dispatch('collections/setNoOfFetch', {noOfFetch: Object.keys(sources).length})
    // console.log('setNoOfFetch')
    Object.keys(sources).forEach(function (sourceKey) {
      solrQuery.fetchNoOfBook(vm, sourceKey)
    })
    // this.search()
  },
  computed: {
    page: function () {
      return this.$store.getters['collections/getPage']
    },
    selectedBook: function () {
      let selectedBook = this.$store.getters['collections/getSelectedBook']
      let displayTitles = this.allTitles.slice(this.page * this.noPerPage, (this.page + 1) * this.noPerPage)
      if (displayTitles.length > 0 && !displayTitles.indexOf(selectedBook) === -1) {
        this.$store.dispatch('collections/setSelectedBook', {selectedBook: displayTitles[0]})
        return displayTitles[0]
      } else {
        return selectedBook
      }
    },
    allTitles () {
      // let filteredBooks = this.$store.state.collections.filteredBooks
      // if (filteredBooks.length > 0) {
      //   return this.$store.state.collections.allBooksId.filter(x => filteredBooks.indexOf([x[0], x[2]].join('|')) > -1)
      // } else {
      //   return this.$store.state.collections.allBooksId
      // }
      return this.$store.getters['collections/getValidBooks']
    },
    noOfAllTitles () {
      // console.log(this.$store.state.collections.noOfBooks)
      return this.$store.getters['collections/getAllNoOfBooks']
    },
    results () {
      return this.$store.state.records.records
    },
    facets () {
      return this.$store.state.collections.facets
    },
    selectedFacets () {
      return this.$store.getters['collections/getSelectedFacets']
      // return this.$store.state.facets.selectedFacets
    },
    noOfAllPagesHits () {
      return this.$store.getters['collections/getAllNoOfPages']
    },
    // noOfFetch () {
    //   return this.$store.getters['collections/getAllNoOfPages']
    // },
    // Only fetch small portion for display in Block module.
    noOfpages: function () {
      /*
        if (vm.$store.getters['collections/getNoOfBooks'](sourceKey) < vm.$store.getters['collections/getTotalNoOfBooks'](sourceKey)) {
    vm.keepSearch(sourceKey)
  }
      */
      let totalPage = parseInt(this.noOfAllTitles / this.noPerPage + (this.noOfAllTitles % this.noPerPage === 0 ? 0 : 1))
      // console.log(totalPage)
      if (totalPage < 8) {
        return _.range(0, totalPage)
      } else {
        let start = Math.max(0, this.page - 3)
        let end = Math.min(start + 9, totalPage)
        if ((start + 9) > totalPage) {
          end = totalPage
          start = Math.max(0, end - 9)
        }
        return _.range(start, end)
      }
    }
  }
}
</script>

<style scoped>
table tr:nth-child(odd) {
  background-color: #f2f2f2; /* Light gray for odd rows */
}

table tr:nth-child(even) {
  background-color: #ffffff; /* White for even rows */
}
table tr:hover {
  background-color: #ddd; /* Light highlight when hovering */
}
#lockBtn .tooltiptext {
  visibility: hidden;
  /*width: 120px;*/
  background-color: #b41815;
  color: #fff;
  text-align: center;
  padding: 5px 5px 5px 5px;
  margin: -0.5rem 0rem 0rem 1rem;
  border-radius: 6px;
 
  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
}

#lockBtn .tooltiptext::after {
  content: " ";
  position: absolute;
  top: 50%;
  right: 100%; /* To the left of the tooltip */
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent #b41815 transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
#lockBtn:hover .tooltiptext {
  visibility: visible;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  padding-left:0px;
  padding-right:0px;
}
#container {
    margin: 0;
}
/*h2 {*/
/*  clear: left;*/
/*  padding-top: 20px;*/
/*  color: #333;*/
/*  font-size: 13px;*/
/*}*/
.col {
  padding-left: 0px;
  padding-right: 0px;
}
/*ul {*/
/*  list-style: none;*/
/*  padding-left: 0px;*/
/*  font-size: small;*/
/*}*/
div.pageCluster {
  padding-top: 10px;
  /*position: absolute;*/
  /*overflow-y: scroll;*/
  /*padding-right: 17px;*/
  min-height: 500px;
  /*cursor:ns-resize;*/
}
/*span {*/
/*  font-size: small;*/
/*}*/

span.active {
  color: #b41815 !important;
}

span.clickable:hover {
  cursor: pointer;
}
.fa-icon {
  width: 1em;
  height: 1em; /* or any other relative font sizes */

  /* You would have to include the following two lines to make this work in Safari */
  max-width: 100%;
  max-height: 100%;
}
a {
 color: #b41815 !important;
}
a:hover  {
  color: black;
  cursor: pointer;
}
/*#titles {*/
/*  line-height: 150%;*/
/*}*/

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-20%);
  opacity: 0;
}

#searchBtn {
    background-color: #b41815;
    border-color: #861210;
    border-radius: 5px;
    border-style: solid;
    border-width: 1px;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    font-weight: bold;
    /*font-size: 1em;*/
    /*padding: 4px;*/
    /*line-height: 1;*/
    /*right: 52px;*/
    text-align: center;
}

#lockBtn {
    /*background-color: #b41815;*/
    /*border-color: #861210;*/
    /*border-radius: 5px;*/
    /*border-style: solid;*/
    /*border-width: 1px;*/
    color: #b41815;
    cursor: pointer;
    display: inline-block;
    font-weight: bold;
    /*font-size: 1em;*/
    /*padding: 4px;*/
    /*line-height: 1;*/
    /*right: 52px;*/
    text-align: center;
}
/*.row {*/
/*  margin-right: 15px !important;*/
/*}*/
.simplert {
  text-align: left !important;
}
.simplert__title {
    font-size: 1.5em !important;
}

.row {
     margin-right: 0px !important;
     margin-left: 0px !important;
}

.blockRange.row {
  margin-right: -15px !important;
  margin-left: -15px !important;
}

#container {
  padding-top: 1em;
}
a {
  cursor: pointer !important;
}
</style>
<style>


.nav-tabs-wrapper .title {
  font-size: 1.5em !important;
}

.tab-content {
  font-size: 1.3em !important;
}

.vue-tabs .nav-tabs > li.active a:before {
    border-bottom: 11px solid #b41815 !important;
}

.vue-tabs .nav-tabs > li.active a:before {
    border-bottom: 11px solid #b41815 !important;
}

.vue-tabs .nav-tabs > li > a {
    color: #555 !important;
}

.vue-tabs .nav-tabs-navigation {
    border-bottom: 1px solid #b41815 !important;
}
/*header .container img {*/
/*  display:none;    */
/*}*/
/*header .container.default {*/
/*    height: 50px !important;*/
/*}*/
.breadcrumb {
    margin-bottom: 0px !important;
}

.jumbotron {
     padding-top: 0px !important;
     padding-bottom: 0px !important;
     margin-bottom: 0px !important;
}
h4 {
  padding: 0px;
}

/* width */
::-webkit-scrollbar {
    width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
    background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #555; 
}

input[type='checkbox']{
  cursor: default;
}
input[type='checkbox']:hover{
  cursor: pointer;
}

</style>


// WEBPACK FOOTER //
// src/components/Status.vue